// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3M7TL","location":"Header_location__2mPF7"};